
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broker",
      function () {
        return require("private-next-pages/broker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/broker"])
      });
    }
  